<template>
  <b-col>
    <div ref="card__basic-info" class="card__basic-info">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div ref="text__basic-info-title" class="h5 font-weight-bold m-0">Basic Information</div>
        <a
          v-if="editable"
          ref="button__edit-basic-info"
          class="button__edit-basic-info"
          @click="goToEditBasicInfo"
        >
          <b-img
            ref="icon__edit-basic-info"
            class="icon__edit-basic-info"
            :src="require(`@/assets/user-profile-icons/icon-edit.svg`)"
          />
          Edit
        </a>
      </div>

      <div class="block__basic-info">
        <b-row ref="row__basic-info-age" class="mb-2 row__basic-info">
          <b-col class="row__basic-info-title">
            <b-img
              ref="icon__info-img-age"
              class="icon__info-img icon__info-img-age"
              :src="require(`@/assets/user-profile-icons/icon-cake.svg`)"
            />
            <span class="basic-info__title"> Age </span>
          </b-col>
          <b-col class="basic-info__description">{{ Age }}</b-col>
        </b-row>
      </div>

      <div class="block__basic-info">
        <b-row ref="row__basic-info-country" class="mb-2 row__basic-info">
          <b-col class="row__basic-info-title">
            <b-img
              ref="icon__info-img-country"
              class="icon__info-img icon__info-img-country"
              :src="require(`@/assets/user-profile-icons/icon-location.svg`)"
            />
            <span class="basic-info__title"> Country </span>
          </b-col>

          <b-col class="basic-info__description">{{ Country }}</b-col>
        </b-row>
      </div>

      <div class="block__basic-info">
        <b-row ref="row__basic-info-mobile-number" class="mb-2 row__basic-info">
          <b-col class="row__basic-info-title">
            <b-img
              ref="icon__info-img-mobile-number"
              class="icon__info-img icon__info-img-mobile-number"
              :src="require(`@/assets/user-profile-icons/icon-phone.svg`)"
            />
            <span class="basic-info__title"> Phone Number </span>
          </b-col>
          <b-col class="basic-info__description">{{ mobileNumber }}</b-col>
        </b-row>
      </div>

      <hr class="my-4" />

      <div ref="text__occupation-goals-title" class="h5 font-weight-bold m-0">Occupation Goals</div>

      <div class="block__occupation-goals">
        <div ref="text__current-occupation-title" class="basic-info__title mt-u6">
          Current occupation
        </div>
        <div ref="text__current-occupation-detail" class="basic-info__description">
          {{ currentOccupation }}
        </div>
      </div>

      <div class="block__occupation-goals">
        <div ref="text__desired-occupation-title" class="basic-info__title mt-u6">
          Interested occupation
        </div>
        <div ref="text__desired-occupation-detail" class="basic-info__description">
          {{ desiredOccupation }}
        </div>
      </div>

      <div class="block__occupation-goals">
        <div ref="text__experience-level-title" class="basic-info__title mt-u6">
          Job level/ Job Position
        </div>
        <div ref="text__experience-level-detail" class="basic-info__description">
          {{ experienceLevel }}
        </div>
      </div>

      <div class="block__occupation-goals">
        <div ref="text__goals-title" class="basic-info__title mt-u6">Goals</div>
        <div ref="text__goals-detail" class="basic-info__description">{{ goals }}</div>
      </div>
    </div>
  </b-col>
</template>

<script>
import * as PROFILE_OPTIONS from '@/assets/user-profile-template.json';
import * as PROFILE_ORIGINAL_OPTIONS from '@/assets/user-profile-template-original.json';

export default {
  props: {
    editable: {
      type: Boolean,
      default: false
    },

    user: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    Age() {
      return this.user?.age ? this.user.age : '-';
    },
    Country() {
      return this.user?.country ? this.countries[this.user.country] : '-';
    },
    mobileNumber() {
      return this.user?.phone_number ? this.user.phone_number : '-';
    },
    currentOccupation() {
      return this.user?.current_occupation
        ? this.currentOccupations[this.user.current_occupation]
          ? this.currentOccupations[this.user.current_occupation]
          : this.user.current_occupation.split('|')[1]
        : '-';
    },

    desiredOccupation() {
      return this.user?.desired_occupation
        ? this.desiredOccupations[this.user.desired_occupation]
          ? this.desiredOccupations[this.user.desired_occupation]
          : this.user.desired_occupation.split('|')[1]
        : '-';
    },

    goals() {
      return this.user?.goals && this.user?.goals.length > 0
        ? [...this.user.goals].join(', ')
        : '-';
    },

    experienceLevel() {
      return this.user?.experience_level ? this.experienceLevels[this.user.experience_level] : '-';
    },

    currentOccupations() {
      const results = {};
      PROFILE_OPTIONS.aboutYouFields.fields.currentOccupation.options.forEach((option) => {
        results[option.value] = option.name;
      });
      return results;
    },

    desiredOccupations() {
      const results = {};
      PROFILE_OPTIONS.aboutYouFields.fields.desiredOccupation.options.forEach((option) => {
        results[option.value] = option.name;
      });
      return results;
    },
    experienceLevels() {
      const results = {};
      PROFILE_OPTIONS.aboutYouFields.fields.experienceLevel.options.forEach((option) => {
        results[option.value] = option.name;
      });
      return results;
    },
    countries() {
      const results = {};
      PROFILE_ORIGINAL_OPTIONS.aboutYouFields.fields.country.options.forEach((option) => {
        results[option.value] = option.name;
      });
      return results;
    }
  },

  methods: {
    goToEditBasicInfo() {
      return this.$router.push({ name: 'profile/basic-info/edit' });
    }
  }
};
</script>

<style lang="scss" scoped>
.card__basic-info {
  background: #ffffff;
  border: 1px solid rgba(209, 210, 219, 1);
  border-radius: 12px;
  padding: 25px;
}

.row__basic-info-title {
  padding: 0 !important;
  display: flex;
  gap: 8px;
  align-items: center;
}

.icon__info-img {
  width: 16px;
  height: 16px;
}

.icon__info-img-age {
  width: 20px;
  height: 20px;
}

.basic-info__title {
  opacity: 0.5;
  padding: 0 !important;
}

.row__basic-info {
  display: grid;
  align-items: start;
  grid-template-columns: 50% 50%;
  gap: 12px;
}

.row__basic-info.row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.basic-info__description {
  overflow-wrap: break-word;
  word-wrap: break-word;
  overflow: auto;
  white-space: normal;
}

.basic-info__description.col {
  padding: 0 !important;
}

.button__edit-basic-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3c44b1 !important;
  cursor: pointer;
}

.icon__edit-basic-info {
  width: 20px;
  height: 20px;
}

.block__basic-info {
  display: grid;
  align-items: start;
  grid-template-columns: 90% 10%;
}

.block__occupation-goals {
  display: grid;
  grid-template-columns: 1fr;
}

@media screen and (max-width: 425px) {
  .block__basic-info {
    grid-template-columns: 100%;
  }
}

@media screen and (min-width: 576px) {
  .block__basic-info {
    grid-template-columns: 95% 5%;
  }
  .row__basic-info {
    grid-template-columns: 30% 70%;
  }
}
</style>
